const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquiggly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "18.936 27.716 468.171 41.533",
    width: 500,
    height: 41.533,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "var(--light)",
      fill: "none"
    },
    d: "M 18.936 49.154 C 37.3 81.87 81.002 68.6 91.813 50.438 C 110.9 18.371 159.735 24.592 173.663 50.509 C 189.705 80.36 251.567 69.868 260.163 51.403 C 278.499 12.014 333.699 28.595 348.217 51.859 C 361.35 72.903 407.062 73.227 417.956 51.332 C 431.612 23.885 477.776 28.595 487.107 50.363"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquiggly);
export default __webpack_public_path__ + "static/media/Squiggly.193f343c954204e55addafda09551ce1.svg";
export { ForwardRef as ReactComponent };